import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { spaceL, spaceXXL } from '@xingternal/tokens';
import { Headline as HeadlineComponent } from '@xingternal/typography';

import { LoadingError } from '@/components/_common';

export const Headline = styled(HeadlineComponent)`
  margin-top: 50px;

  @media ${mediaWide} {
    margin-top: 68px;
    margin-bottom: ${spaceXXL};
  }
`;

export const ErrorBanner = styled(LoadingError)`
  margin-top: ${spaceL};

  @media ${mediaConfined} {
    margin: 48px 0 18px 0;
  }
`;
